export function readLayout(system) {
  try {
    const raw = localStorage.getItem(system.layoutStorageKey);
    return raw ? JSON.parse(raw) : {};
  } catch (_err) {
    return {};
  }
}

export function writeLayout(system, layout) {
  try {
    localStorage.setItem(system.layoutStorageKey, JSON.stringify(layout));
  } catch (_err) {
    /* localStorage may be unavailable. Layout persistence is best-effort. */
  }
}

export function restoreLayout(system) {
  if (system.isMobileLayout()) return;
  const layout = readLayout(system);
  document.querySelectorAll('.panel[id]').forEach((panel) => {
    const saved = layout[panel.id];
    if (!saved) return;

    if (saved.width) panel.style.width = saved.width;
    if (saved.height) panel.style.height = saved.height;
    if (saved.transform) panel.style.transform = saved.transform;
    panel.classList.toggle('minimized', Boolean(saved.minimized));

    const btn = panel.querySelector('.minimize-btn');
    if (btn) {
      btn.textContent = saved.minimized ? '+' : '–';
      btn.setAttribute('aria-label', saved.minimized ? 'Restore Panel' : 'Minimize Panel');
    }
  });
}

export function saveLayout(system) {
  if (system.isMobileLayout()) return;
  const layout = {};
  document.querySelectorAll('.panel[id]').forEach((panel) => {
    layout[panel.id] = {
      transform: panel.style.transform || '',
      width: panel.style.width || '',
      height: panel.style.height || '',
      minimized: panel.classList.contains('minimized')
    };
  });
  writeLayout(system, layout);
}
